module.exports = {
      id: "tag-usage",
      viewBox: "0 0 30.383 24.21",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#tag",
      toString: function () {
        return this.url;
      }
    }